export const hotDramas = [
  {
    id: 'hot-1',
    title: '长夜微光',
    genre: '悬疑 / 都市',
    region: '中国大陆',
    episodes: 36,
    status: '更新至 28 集',
    rating: '8.7',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20suspense%20drama%20poster%20art%2C%20rainy%20city%20street%20at%20night%20with%20warm%20amber%20street%20lights%2C%20silhouette%20of%20a%20detective%20figure%2C%20crimson%20and%20golden%20orange%20palette%2C%20moody%20dramatic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20texture&width=600&height=800&seq=cth-hot-01&orientation=portrait',
    note: '一桩旧案牵出整座城市的暗面，节奏克制但每个细节都藏着线索。',
  },
  {
    id: 'hot-2',
    title: '江城旧事',
    genre: '年代 / 家庭',
    region: '中国大陆',
    episodes: 42,
    status: '已完结',
    rating: '9.1',
    year: 2024,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20art%2C%20old%20riverside%20town%20alley%20in%20warm%20golden%20afternoon%20light%2C%20retro%201990s%20Chinese%20architecture%2C%20amber%20and%20brown%20tones%2C%20nostalgic%20melancholy%20mood%2C%20no%20text%2C%20rich%20textured%20editorial%20style&width=600&height=800&seq=cth-hot-02&orientation=portrait',
    note: '一条江、三代人，把三十年的变迁讲得稳稳当当，适合慢看。',
  },
  {
    id: 'hot-3',
    title: '归海',
    genre: '古装 / 权谋',
    region: '中国大陆',
    episodes: 48,
    status: '更新中',
    rating: '8.4',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20political%20drama%20poster%20art%2C%20lone%20figure%20in%20flowing%20robes%20standing%20before%20a%20vast%20palace%20hall%2C%20dramatic%20amber%20torchlight%2C%20deep%20crimson%20drapes%2C%20warm%20golden%20palette%2C%20epic%20royal%20atmosphere%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=cth-hot-03&orientation=portrait',
    note: '朝堂棋局层层递进，人物立场随剧情不断反转，追更新体验很上头。',
  },
  {
    id: 'hot-4',
    title: '逆风而行',
    genre: '都市 / 职场',
    region: '中国大陆',
    episodes: 30,
    status: '已完结',
    rating: '8.0',
    year: 2024,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20modern%20workplace%20drama%20poster%20art%2C%20confident%20young%20professional%20walking%20through%20a%20glass%20office%20tower%20at%20warm%20sunset%2C%20amber%20and%20orange%20glow%2C%20minimal%20clean%20composition%2C%20no%20text%2C%20editorial%20photography%20style&width=600&height=800&seq=cth-hot-04&orientation=portrait',
    note: '创业线与职场线并行，讲得实在，不回避现实的难处。',
  },
  {
    id: 'hot-5',
    title: '星河以北',
    genre: '科幻 / 悬疑',
    region: '中国大陆',
    episodes: 24,
    status: '更新至 12 集',
    rating: '8.9',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20drama%20poster%20art%2C%20astronaut%20silhouette%20before%20a%20glowing%20amber%20nebula%2C%20warm%20orange%20and%20crimson%20space%20clouds%2C%20dramatic%20volumetric%20light%2C%20epic%20mysterious%20atmosphere%2C%20no%20text%2C%20high%20detail%20texture&width=600&height=800&seq=cth-hot-05&orientation=portrait',
    note: '硬核设定配情感内核，信息量大，建议整季连看更连贯。',
  },
  {
    id: 'hot-6',
    title: '春日回信',
    genre: '爱情 / 治愈',
    region: '中国大陆',
    episodes: 28,
    status: '已完结',
    rating: '7.8',
    year: 2024,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20healing%20drama%20poster%20art%2C%20sunlit%20spring%20garden%20with%20blooming%20flowers%20and%20warm%20golden%20light%2C%20soft%20amber%20tones%2C%20gentle%20dreamy%20atmosphere%2C%20delicate%20bokeh%2C%20no%20text%2C%20editorial%20style&width=600&height=800&seq=cth-hot-06&orientation=portrait',
    note: '慢热治愈系，画面舒服，适合周末一次看个几集放松。',
  },
];